<template>
    <pm-app v-if="loaded" :class="$theme.themeRootClass">
        <template slot="default">
            <keep-alive :include="['xPmModGallery', 'xPlan','xPmModAnimations']">
                <router-view v-if="loaded" :key="$route.fullPath + $store.state.localSettings.dentalNotation" />
            </keep-alive>

            <pm-app-dialog />

            <div v-if="isDev" style="pointer-events: none; border: 3px solid #fff; font-weight: 600; background: #f00; color: #fff; position: fixed; z-index: 99999999; font-size: 11px; padding: 1px 30px; top: 10px; right: -30px; transform: rotate(45deg);">DEBUG</div>
        </template>
    </pm-app>
</template>

<style lang="scss">
    .theme-dark *::-webkit-scrollbar-track {
        background: #212121;
    }
    .theme-dark *::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 6px;
        border: 3px solid #212121;
    }

    html, body {
        background: #000 !important;
    }

    .info-rotated-iPad {
        display: none;
    }

    @media (orientation: landscape) {
        .info-rotated-iPad {
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 20;
            width: 100vw;
            height: 100vh;
            background: linear-gradient(145deg, #2c81ff, #256de6);
            box-shadow: 20px 20px 60px #2367d9, -20px -20px 60px #2f8bff;
            justify-content: center;
            align-items: center;
            font-size: 2vw;
            color: white;
        }

        .rotate-content {
            position: fixed;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            background-color: #2c81ff;
            z-index: 15;
            align-items: center;
            justify-content: center;
            display: flex;
            pointer-events: auto;
        }

        .rotate-box {
            width: 80%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .rotate-device-img {
            width: 30%;
            filter: invert(1);
        }
        .rotate-device-img svg {
            max-width: 100%;
        }

        .rotate-text {
            color: #f1f1f1;
            text-align: center;
        }

        .rotate-title {
            font-size: 20px;
            margin-bottom: 10px;
            margin-top: 30px;
        }

        .rotate-subtitle {
            font-size: 14px;
        }
    }

    #video {
        width: 100vw;
        height: 100vh;
        z-index: 20;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #000;
    }

    .btn--skip {
        position: absolute;
        right: 0.5rem;
        bottom: 0.5rem;
        z-index: 25;
    }

    .renderfix {
        transform: translate3d(0,0,0);
        -webkit-transform: translate3d(0,0,0);
    }
</style>

<script>
import "../styles/main.scss";
import PmApp from "./core/pm-app";
import PmAppComponent from "./core/pm-app-component";
import SimplePlanStore from "../extensions/vuex/store-simple-plan";
import request from "superagent";
import flutterPaymentMixin from "../extensions/mixins/mixin-flutter-payment";
import { measureUsageTime } from "../utils/analytics/user-type";
import PmAppDialog from "@/components/dialogs/app-dialogs.vue";
import { validateStoreConnection } from "@/utils/iap/store-connection";
import { initSettings } from "@/utils/settings";
import { callUpdateWebhook } from "@/utils/webhooks/newsletter.js";

export default {
    name: "App",
    components: {
        PmApp,
        PmAppDialog,
    },
    mixins: [
        flutterPaymentMixin
    ],
    data: () => ({
        loaded: false,
        plan3settingsLoaded: false,
        assetsLoaded: 0,
        requiredAssets: ["countries.json", "tooth_images.json"],
        isDev: false,
        firstRun: false,
    }),
    beforeCreate() {
        Vue.component("pm-app-component", PmAppComponent);

        // @todo: máshonnan kiszedni
        if (typeof this.$store.state.simplePlan === "undefined") {
            this.$store.registerModule("simplePlan", SimplePlanStore);
        }
    },
    created() {

        measureUsageTime(30);

        this.registerBusEvent("flutter.settings", (param) => {
            window.flutterEventLog.unshift({
                eventName: "initSettings-flutter.settings",
                data: {},
            });
            initSettings(param);
            this.loaded = true;
        });

        window.addEventListener("offline", () => {
            this.$store.state.networkStatus = "offline";
        });

        window.addEventListener("online", () => {
            this.$store.state.networkStatus = "online";
        });

        window.addEventListener("FlutterMessage", (e) => {
            try {
                const msgObj = e.detail;
                // eslint-disable-next-line no-console
                console.log(msgObj);
                app.$bus.$emit("flutter:" + msgObj.name, msgObj.data);
            } catch(error) {
                captureException(error);
            }
        }, false);

        this.registerBusEvent("flutter:trialStatus", (data) => {
            localStorage.setItem("trialStatus", data.expired);
        });

        this.registerBusEvent("flutter:paymentStateChanged", (data) => {
            localStorage.setItem("subscriptionStatus", data.subscriptionStatus);
        });
        this.registerBusEvent("flutter:priceLoaded", (data) => {
            localStorage.setItem("priceString", data.priceString);
        });

        this.registerBusEvent("debug:toggled", (data) => {
            this.isDev = localStorage.getItem('isDevMode') === "true";
        });

        this.$store.commit("loadDataFromLocalStorage");

        this.registerBusEvent("flutter:fileLoaded", (data) => {
            try {
                if (data.fileName === "countries.json") window.CountryJson = JSON.parse(atob(data.fileData));
                if (data.fileName === "tooth_images.json") window.ToothImagesJson = JSON.parse(atob(data.fileData));
                if (this.requiredAssets.includes(data.fileName)) this.assetsLoaded++;
                if (this.assetsLoaded === this.requiredAssets.length) {
                    window.flutterEventLog.unshift({
                        eventName: "initSettings-flutter.fileLoaded",
                        data: {},
                    });
                    initSettings(localStorage.getItem("settings"));
                    this.loaded = true;
                }
            } catch(error) {
                captureException(error);
            }
        });
    },
    async mounted() {
        validateStoreConnection();

        if (typeof FlutterIsProService !== "undefined" && typeof FlutterIsVueMountedService !== "undefined") {
            // eslint-disable-next-line no-undef
            FlutterIsVueMountedService.postMessage("created");
        } else {
            const ToothImagesJsonResp = await this.getJSON("/json/tooth_images.json");
            // https://restcountries.eu/rest/v2/all?fields=name;nativeName;currencies;languages;alpha2Code;altSpellings
            const CountryJsonResp = await this.getJSON("/json/countries.json");

            window.ToothImagesJson = ToothImagesJsonResp;
            window.CountryJson = CountryJsonResp;

            window.flutterEventLog.unshift({
                eventName: "initSettings-mounted",
                data: {},
            });
            initSettings(localStorage.getItem("settings"));
            this.loaded = true;
        }
        window.runPendingFlutterEvents();

        this.plan3settingsLoaded = true;

        this.isDev = localStorage.getItem('isDevMode') === "true";

        window.Tracker.logEvent({
            event_name: "open_app",
            event_category: "app",
            event_label: window.appVersion,
        });

        this.updateLastOpenedDate();
    },


    methods: {
        async getJSON(src) {
            try {
                const response = await request.get(src);
                return await response.body;
            } catch(error) {
                captureException(error);
            }
        },

        updateLastOpenedDate() {
            try {
                const email = localStorage.getItem('userEmailSend');
                if (email) {
                    let today = new Date();
                    callUpdateWebhook(email, 'DC_LAST_OPEN', today.toISOString().split('T')[0]);
                }
            } catch(error) {
                captureException(error);
            }
        }
    },
};
</script>
